/* eslint-disable no-console */
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: 'AIzaSyASLDfpVC-xgqVOzruzC8_0oJ93HVSzpAA',
    authDomain: 'morfie-kanisa.firebaseapp.com',
    projectId: 'morfie-kanisa',
    storageBucket: 'morfie-kanisa.appspot.com',
    messagingSenderId: '1018733116224',
    appId: '1:1018733116224:web:a8ebd3da3bc16ad7e0d8a5',
    measurementId: 'G-2F36W47N46',

    // apiKey: 'AIzaSyCRmNEkLF4wvO-N4_KBzW1py1p0z4Az5x0',
    // authDomain: 'interest-hub.firebaseapp.com',
    // databaseURL: 'https://interest-hub-default-rtdb.firebaseio.com',
    // projectId: 'interest-hub',
    // storageBucket: 'interest-hub.appspot.com',
    // messagingSenderId: '999733536711',
    // appId: '1:999733536711:web:8934106138dc7b1b2f5be2',
    // measurementId: 'G-XWYNENMHJS',
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

const messaging = getMessaging(firebaseApp);
const database = getDatabase(firebaseApp);

export { onMessage, getToken, messaging, database };
